<script lang="ts">
  import { onMount } from 'svelte'
  import { roundNumber } from '../utils/datasets'

  export let max: number
  export let maxAcceptable: number
  export let mean: number
  export let min: number
  export let minAcceptable: number
  export let UOM: string = ''

  let element: HTMLElement | undefined

  onMount(() => {
    if (!element || !minAcceptable || !maxAcceptable) return

    const range = maxAcceptable - minAcceptable
    const minPercent = ((min - minAcceptable) / range) * 100
    const meanPercent = ((mean - minAcceptable) / range) * 100
    const maxPercent = ((max - minAcceptable) / range) * 100

    element.style.setProperty('--min', `${minPercent}%`)
    element.style.setProperty('--mean', `${meanPercent}%`)
    element.style.setProperty('--max', `${maxPercent}%`)
  })
</script>

<style lang="scss">
  .minmax {
    --min: 10%;
    --mean: 50%;
    --max: 90%;
    font-size: 0.5rem;
    margin-left: auto;
    max-width: 400px;
    min-width: 200px;
    width: 100%;
  }

  .row {
    display: flex;
    justify-content: space-between;
  }

  .visual {
    align-content: center;
    background-image:
      linear-gradient(
        to right,
        transparent calc(var(--min) - 1px),
        $primary calc(var(--min) - 1px) calc(var(--min) + 1px),
        transparent calc(var(--min) + 1px)
      ),
      linear-gradient(
        to right,
        transparent calc(var(--mean) - 1px),
        $link calc(var(--mean) - 1px) calc(var(--mean) + 1px),
        transparent calc(var(--mean) + 1px)
      ),
      linear-gradient(
        to right,
        transparent calc(var(--max) - 1px),
        $primary calc(var(--max) - 1px) calc(var(--max) + 1px),
        transparent calc(var(--max) + 1px)
      ),
      linear-gradient(
        to right,
        $danger 2px,
        $danger-light 2px,
        $primary-light 10% 90%,
        $danger-light calc(100% - 2px),
        $danger calc(100% - 2px)
      );
    flex: 1;
    height: $spacing;
    padding: $spacing * 0.25 $spacing * 0.5;
    position: relative;
  }
</style>

<!-- svelte-ignore a11y-click-events-have-key-events -->
<div
  bind:this={element}
  class="minmax"
>
  <div class="row">
    <span class:has-text-danger={min < (minAcceptable || 0)}>
      {`Minimum: ${roundNumber(min)} ${UOM}`}
    </span>
    <span class:has-text-danger={max > (maxAcceptable || 100)}>
      {`Maximum: ${roundNumber(max)} ${UOM}`}
    </span>
  </div>
  <div class="visual"></div>
  <div class="row">
    <span class="has-text-danger">Above min</span>
    <span class="has-text-primary">Acceptable range</span>
    <span class="has-text-danger">Above max</span>
  </div>
</div>
